
import BannerContainer from '~/components/child/banner/BannerContainer.vue';
import TagContainer from '~/components/child/tag/TagContainer.vue';
import RecipeContainer from '~/components/child/recipe/RecipeContainer.vue';
import BrowseContainer from '~/components/child/browse/BrowseContainer.vue';
import ArticleChannelContainer from '~/components/child/article/ArticleChannelContainer.vue';
import BloggerRankingChannel from '~/components/child/blogger/BloggerRankingChannel.vue';
import ArticleHotContainer from '~/components/child/article/ArticleHotContainer.vue';
export default {
    name: "travel",
    components: { BannerContainer, TagContainer, RecipeContainer, BrowseContainer, ArticleChannelContainer, BloggerRankingChannel, ArticleHotContainer },
    head() {
        return {
            title: '親子-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '痞客邦的新手媽媽、準媽媽、與老手媽媽們，一起提供私房孕前準備、懷孕生產與產後調理等育兒知識分享，還有各樣育兒經驗分像、寶寶教養與親子想關討論與經驗分享，是新手爸媽找共鳴、找方向以及分享為人父母酸甜苦辣的情報園地！' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '痞客邦的新手媽媽、準媽媽、與老手媽媽們，一起提供私房孕前準備、懷孕生產與產後調理等育兒知識分享，還有各樣育兒經驗分像、寶寶教養與親子想關討論與經驗分享，是新手爸媽找共鳴、找方向以及分享為人父母酸甜苦辣的情報園地！' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '痞客邦的新手媽媽、準媽媽、與老手媽媽們，一起提供私房孕前準備、懷孕生產與產後調理等育兒知識分享，還有各樣育兒經驗分像、寶寶教養與親子想關討論與經驗分享，是新手爸媽找共鳴、找方向以及分享為人父母酸甜苦辣的情報園地！' },
                { hid: 'keywords', name: 'keywords', content: '媽媽、寶寶、親子、育兒、懷孕、生產、教養、學齡兒童、新手媽媽、嬰幼兒、嬰兒、幼兒、幼教' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "親子-PIXNET痞客邦"},
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_child_og.png"},
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_child_og.png"},
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_child_og.png"},
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_child_og.png"},
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/family', key: "canonical"}
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context":"https://schema.org",
                    "@type":"Organization",
                    "url":"https://www.pixnet.net",
                    "logo":"https://www.pixnet.net/img/public/og/img_child_og.png",
                    "name":"痞客邦",
                    "@id":"https://www.pixnet.net/#organization",
                    "description":"痞客邦的新手媽媽、準媽媽、與老手媽媽們，一起提供私房孕前準備、懷孕生產與產後調理等育兒知識分享，還有各樣育兒經驗分像、寶寶教養與親子想關討論與經驗分享，是新手爸媽找共鳴、找方向以及分享為人父母酸甜苦辣的情報園地！",
                    "address":"",
                    "brand":{
                        "@type":"Brand",
                        "logo":"https://www.pixnet.net/img/public/og/img_child_og.png"
                    },
                    "sameAs":"https://www.facebook.com/pixnet.net"
                },
                {
                    "@context":"https://schema.org/",
                    "@type":"BreadcrumbList",
                    "itemListElement":[
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "親子-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "痞客邦的新手媽媽、準媽媽、與老手媽媽們，一起提供私房孕前準備、懷孕生產與產後調理等育兒知識分享，還有各樣育兒經驗分像、寶寶教養與親子想關討論與經驗分享，是新手爸媽找共鳴、找方向以及分享為人父母酸甜苦辣的情報園地！",
                            "keywords": "媽媽、寶寶、親子、育兒、懷孕、生產、教養、學齡兒童、新手媽媽、嬰幼兒、嬰兒、幼兒、幼教"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            channel_page_id: 4,
            category_id: 6,
            showAnimation: false,
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        pa_page_name() {
            return '親子';
        },
        tag_search_text() {
            return '親子';
        },
        day_hot_article() {
            return this.$store.state.article.day_hot_article;
        },
        day_hot_article_full() {
            return this.$store.state.article.day_hot_article_full;
        }
    },
    methods: {
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction(){
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        gtag(){
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '親子'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '親子'
            });
            this.gtag('event', 'page_view', {
                page_title: '親子-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
    },
    async fetch(){
        const item = { sort: 'hot', type: 'group', pre_page: 10, id: this.channel_page_id, cat_id: 6, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticle", item);
    },
    mounted() {
        window.dataLayer = window.dataLayer || [];
        this.activeGaPage();
        this.activeMcPage();
        this.paFunction();
        this.paScrollFunction();
    }
}
